export default function RosevilleAbout() {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-amber-50 to-teal-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-teal-600 font-semibold text-sm mb-3 tracking-wide uppercase">Roseville, California</p>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              The Heart of Placer County
            </h2>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              Nestled in the scenic foothills of the Sierra Nevada, Roseville is one of California's fastest-growing cities and a premier destination in the Greater Sacramento region. With its rich railroad heritage dating back to 1864<sup className="text-teal-600 font-medium cursor-pointer" title="Source: Roseville Historical Society">*</sup>, Roseville has evolved into a vibrant community that perfectly blends historic charm with modern amenities.
            </p>
            <p className="text-gray-700 text-base leading-relaxed mb-6">
              Known for its exceptional quality of life, award-winning parks, world-class shopping at Westfield Galleria, and proximity to Lake Tahoe and Napa Valley wine country, Roseville offers visitors an authentic Northern California experience with year-round sunshine and endless outdoor adventures.
            </p>
            <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3.5 rounded-full text-sm font-semibold transition-all inline-flex items-center space-x-2 whitespace-nowrap cursor-pointer">
              <span>Learn More</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </button>

            {/* Sources Note */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-xs text-gray-400 leading-relaxed">
                <sup>*</sup> Historical data sourced from Roseville Historical Society and City of Roseville Archives. Population and growth statistics from U.S. Census Bureau 2024.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/773c70b74494b9f3dfb09a8c43444e0c.jpg" 
                alt="Historic Old Town Roseville" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
